// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  background: #f6f1ef;
}
.wrapper .header-block {
  height: 70%;
  width: 100%;
  position: relative;
}
.wrapper .header-block ion-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.wrapper .header-block ion-chip {
  position: absolute;
  top: 15px;
  right: 15px;
  margin: 0px;
  background: #f6f1ef;
  width: 35px;
  height: 35px;
  padding: 0px;
  z-index: 99;
}
.wrapper .header-block ion-chip ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.wrapper .header-block ion-chip:hover {
  background: #f2dbd9;
}
.wrapper .footer-section {
  height: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  padding: 20px;
}
.wrapper .footer-section p {
  text-transform: uppercase;
  margin-bottom: 10px;
  text-align: center;
}
.wrapper .footer-section ion-button {
  color: var(--color-black);
  --background:#ebdfda;
}`, "",{"version":3,"sources":["webpack://./src/app/components/order-not-exist-modal/order-not-exist-modal.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;AACJ;AAAI;EACI,WAAA;EACA,WAAA;EACA,kBAAA;AAER;AADQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AAGZ;AADQ;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AAGZ;AAFY;EACI,WAAA;EACA,YAAA;EACA,WAAA;AAIhB;AAFY;EACI,mBAAA;AAIhB;AAAI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;AAER;AADQ;EACI,yBAAA;EACA,mBAAA;EACA,kBAAA;AAGZ;AADQ;EACI,yBAAA;EACA,oBAAA;AAGZ","sourcesContent":[".wrapper {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-direction: column;\n    background: #f6f1ef;\n    .header-block {\n        height: 70%;\n        width: 100%;\n        position: relative;\n        ion-img {\n            width: 100%;\n            height: 100%;\n            object-fit: cover;\n        }\n        ion-chip {\n            position: absolute;\n            top: 15px;\n            right: 15px;\n            margin: 0px;\n            background: #f6f1ef;\n            width: 35px;\n            height: 35px;\n            padding: 0px;\n            z-index: 99;\n            ion-icon {\n                width: 100%;\n                height: 100%;\n                margin: 0px;\n            }\n            &:hover {\n                background: #f2dbd9;\n            }\n        }\n    }\n    .footer-section {\n        height: 30%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-direction: column;\n        width: 100%;\n        padding: 20px;\n        p {\n            text-transform: uppercase;\n            margin-bottom: 10px;\n            text-align: center;\n        }\n        ion-button {\n            color: var(--color-black);\n            --background:#ebdfda;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
